/**
 * Zweck: Beschreibt class DtpZusatzdatentypenBlackeningConfigBox und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/dtp-zusatzdatentypen-blackening-config-box.ts.
 */
export class DtpZusatzdatentypenBlackeningConfigBox {
  id: number;
  matchCode: string;
  pageNum: number;
  x: number;
  y: number;
  height: number;
  width: number;
}
